import { PlusOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { Form, Popconfirm } from 'antd';
import { useEffect, useState } from 'react';
import { upperFirst } from 'lodash';
import { FormInstance } from 'antd';
import { observer } from 'mobx-react';

import { EPButton } from '@/components';
import { useStores } from '@/hooks/use-stores';

import { ConnectionSelectorContainer } from './ConnectionSelector.styles';
import ConnectionSelectorPopconfirmContent from './ConnectionSelectorPopconfirmContent/ConnectionSelectorPopconfirmContent';

interface ConnectionSelectorProps {
  options: { value: string; label: string }[];
  label: string;
  form: FormInstance;
}

const ConnectionSelector = observer(({ label, form, options }: ConnectionSelectorProps) => {
  const { t } = useTranslation();
  const { pidEditStore } = useStores();
  const [isPopconfirmOpen, setIsPopconfirmOpen] = useState(false);
  const fieldName = `connect${upperFirst(label)}`;
  const formConnections = Form.useWatch(fieldName, form) || [];
  const [initialFormConnections, setInitialFormConnections] = useState(formConnections);

  useEffect(() => {
    if (isPopconfirmOpen) {
      pidEditStore.setAssetConnectionsInEditIds(formConnections);
    }
  }, [formConnections, isPopconfirmOpen]);

  useEffect(() => {
    if (isPopconfirmOpen) {
      setInitialFormConnections(formConnections);
    }
  }, [isPopconfirmOpen]);

  const onClickConnectionSelectorButton = () => {
    if (!isPopconfirmOpen) {
      setIsPopconfirmOpen(true);
    }
  };

  const onAddClick = async () => {
    pidEditStore.setAssetConnectionsInEditIds([]);
    setIsPopconfirmOpen(false);
  };

  const onCancelClick = () => {
    form.setFieldValue(fieldName, initialFormConnections);
    pidEditStore.setAssetConnectionsInEditIds([]);
    setIsPopconfirmOpen(false);
  };

  return (
    <ConnectionSelectorContainer>
      <Popconfirm
        title={t(fieldName)}
        description={<ConnectionSelectorPopconfirmContent options={options} form={form} fieldName={fieldName} />}
        open={isPopconfirmOpen}
        okText={t('add')}
        cancelText={t('cancel')}
        onConfirm={onAddClick}
        onCancel={onCancelClick}
        arrow={false}
        icon={false}
      >
        <EPButton
          icon={<PlusOutlined />}
          type="dashed"
          className="connection-selector-button"
          onClick={onClickConnectionSelectorButton}
        >
          {t(label)}
        </EPButton>
      </Popconfirm>
    </ConnectionSelectorContainer>
  );
});

export default ConnectionSelector;
